<template lang="html">
  <div>
    <app-title :title="lang[0]"></app-title>
    <div class="overview">
      <p>{{lang[3]}}</p>
      <p>{{lang[4]}}</p>
    </div>
    <div class="main-wrapper">
      <div class="verification-form" v-if="!uploadedFront">
        <b>{{lang[1]}}</b>
        <div class="user-form">
          <input
            id="front-img"
            type="file"
            name="file"
            accept="image/*"
            @change="selectedFile"
            style="dipslay: none;"
          >
        </div>
        <btn class="right-btn" size="normal" type="primary" label="post" @click="upload('frontImg')" :loading="loading"></btn>
      </div>
      <div class="verification-form" v-else>
        <b>{{lang[1]}}</b>
        <p>{{lang[5]}}</p>
        <div class="user-form">
        </div>
        <!-- <btn size="normal" type="cancel" label="post"></btn> -->
      </div>

      <div class="verification-form" v-if="!uploadedBack">
        <b>{{lang[2]}}</b>
        <div class="user-form">
          <input
          :id="`back-img`"
          type="file"
          name="file"
          accept="image/*"
          @change="selectedFile"
          style="dipslay: none;"
          >
        </div>
        <btn class="right-btn" size="normal" type="primary" label="post" @click="upload('backImg')" :loading="loading"></btn>
      </div>
      <div class="verification-form" v-else>
        <b>{{lang[2]}}</b>
        <p>{{lang[5]}}</p>
        <div class="user-form">
        </div>
        <!-- <btn size="normal" type="cancel" label="post"></btn> -->
      </div>

    </div>
    <app-menu active="profile"></app-menu>
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
  </div>
</template>

<script>
import axios from 'axios'
import Btn from '../../components/Button.vue'
import AppMenu from '../../components/Menu.vue'
import AppTitle from '../../components/Title.vue'
import Notice from '../../components/Notice.vue'
import stripeCountryMaster from '../../masters/stripeCountryMaster'
import stirpeCurrencyMaster from '../../masters/stirpeCurrencyMaster'
import AccountVerificationLangMaster from '../../masters/langMaster/AccountVerificationLangMaster'
import stripeErrorHandle from '../../mixins/stripeErrorHandle.js'

export default {
  name: 'Profile address',
  components: {
    Btn,
    AppMenu,
    Notice,
    AppTitle,
  },

  mixins: [stripeErrorHandle],

  data() {
    return {
      lang: AccountVerificationLangMaster[this.$store.state.account.lang],
      frontImg: {},
      backImg: {},
      identityData: {},
      uploadFile: null,
      isNotice: '',
      loading: false,
      noticeType: '',
      noticeTitle: '',
      noticeText: '',
      isNotice: false,
      uploadedFront: false,
      uploadedBack: false,
    }
  },

  created() {
    this.getVerificationId()
  },

  methods: {
    selectedFile(e) {
      this.loading = true
      e.preventDefault()
      this.uploadFile = e.target.files[0]
      let uploadData = new FormData()
      uploadData.append('file', this.uploadFile)
      if(e.target.id === 'front-img') {
        this.frontImg = uploadData
        this.loading = false
      } else {
        this.backImg = uploadData
        this.loading = false
      }
    },

    getVerificationId() {
      axios.get(`private/stripe/account/${this.$store.state.account.stripe_id}`)
      .then(data => {
        if(data.data.data.individual.verification.document) {
          if(data.data.data.individual.verification.document.front !== null) {
            this.uploadedFront = true
          }
          if(data.data.data.individual.verification.document.back !== null) {
            this.uploadedBack = true
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },

    upload(imgName) {
      this.loading = true
      axios.post('private/stripe/upload', this[imgName], {headers: {"content-type": "multipart/form-data"}} )
      .then(data => {
        this.saveImg(data.data.data.id, data.data.data.links.url, imgName)
      }).catch(err => {
        this.stripeErrorHandling(err)
      })
    },

    saveImg(file_id, file_url, purpose) {
      axios.post('private/verification', {
        user_id: this.$store.state.account.id,
        file_id: file_id,
        file_url: file_url,
        purpose: purpose
      })
      .then(data => {
        if(purpose === 'frontImg') {
          this.verificationUpdate('front', file_id)
        } else {
          this.verificationUpdate('back', file_id)
        }
      }).catch(err => {
        this.stripeErrorHandling(err)
      })
    },

    verificationUpdate(where, content) {
      let individual = {}
      if(where === 'front') {
        individual = {verification: {document: {front: content}}}
      } else {
        individual = {verification: {document: {back: content}}}
      }
      axios.post('private/stripe/account/update', {
        id: this.$store.state.account.stripe_id,
        individual: individual
      }).then(data => {
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'Image uploaded successfully!'
        this.isNotice = true
        setTimeout(this.isNotice = false, 5000)
        this.loading = false
        this.getVerificationId()
      }).catch(err => {
        this.stripeErrorHandling(err)
      })
    }
  }
}
</script>

<style lang="css" scoped>
.user-form {
  margin: 20px;
  display: flex;
}

.main {
  padding-bottom: 100px;
}

.user-form input, .user-form select {
  font-size: 16px;
  margin-left: 3px;
  /* appearance: none; */
  width: 100%;
}

.overview {
  background: #f0f0f0;
  margin: 10px auto;
  padding: 5px;
  width:85%;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.verification-form {
  margin:20px auto;
  width: 90%;
}

.right-btn {
  width: 100%;
  text-align: right;
}

@media(min-width: 800px) {
  .user-image {
    height: 30vh;
  }

  .profile-wrapper {
    width: 90%;
    max-width: 800px;
    margin: 40px auto;
  }
}
</style>
